<template>
  <v-card
    v-if="visible"
    :style="menuStyle"
    class="aggregation-table-edit-menu"
  >
    <v-card-subtitle>{{ title }}</v-card-subtitle>

    <v-card-text>
      <v-checkbox
        v-if="isBoolean"
        :input-value="localValue"
        autofocus
        dense
        hide-details
        :disabled="disabled"
        @change="localValue = $event"
      />
      <v-text-field
        v-else-if="isNumber"
        v-model="localValue"
        v-format-number-on-blur
        autofocus
        type="number"
        inputmode="numeric"
        pattern="[0-9]*"
        dense
        hide-details
        :disabled="disabled"
      />
      <v-text-field
        v-else
        v-model="localValue"
        autofocus
        :type="inputType"
        dense
        hide-details
        :disabled="disabled"
      />
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        small
        @click="$emit('cancel')"
      >
        キャンセル
      </v-btn>
      <v-btn
        color="primary"
        small
        :disabled="disabled"
        @click="handleSave"
      >
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import formatNumberOnBlur from '@/directives/formatNumberOnBlur'

export default {
  name: 'AggregationTableEditMenu',
  directives: {
    formatNumberOnBlur,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    isBoolean: {
      type: Boolean,
      default: false,
    },
    isNumber: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    menuStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const localValue = ref(props.value)

    watch(
      () => props.value,
      newVal => {
        localValue.value = newVal
      },
    )

    watch(
      () => props.visible,
      newVal => {
        if (newVal) {
          localValue.value = props.value
        }
      },
    )

    const handleSave = () => {
      emit('save', localValue.value)
    }

    return {
      localValue,
      handleSave,
    }
  },
}
</script>

<style lang="scss" scoped>
.aggregation-table-edit-menu {
  position: fixed;
  z-index: 1001;
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
</style>
